import React, { createRef } from 'react';

const renderAOFCollectionContent = aofCollectionName => (
  <input
    className='create-aof-collection-input'
    ref={aofCollectionName}
    placeholder='...'
    autoFocus
    tabIndex='1'
    type='text'
  />
);

const renderNotebookContent = notebookNameInput => (
  <input
    className='create-notebook-input'
    ref={notebookNameInput}
    placeholder='...'
    tabIndex='1'
    type='text'
  />
);

export const CreateAreaOfFocusModal = (props) => {
  let aofCollectionName = createRef();
  const {
    updateModal,
    closeModal,
    createAOFCollection,
  } = props;

  const saveAOFCollection = aofCollectionName => {
    let aofCollectionObject = {};
    if (!aofCollectionName.current.value.trim()) {
      return;
    }
  
    aofCollectionObject = {
      title: aofCollectionName.current.value,
      app_created_with: 'drynotes_web',
    };
  
    createAOFCollection(aofCollectionObject);
    closeModal();
  }

  updateModal({
    visible: true,
    title: 'Create New Area of focus collection',
    sectionClassName: 'create-aof-modal',
    showCloseModal: false,
    content: renderAOFCollectionContent(aofCollectionName),
    primaryButton: {
      title: 'Save',
      callback: () => {
        saveAOFCollection(aofCollectionName)
      },
    },
    secondaryButton: {
      title: 'Cancel',
      callback: closeModal,
    },
  });
}

export const CreateNotebookModal = props => {
  const {
    updateModal,
    closeModal,
    createNotebook
  } = props;

  let notebookNameInput = createRef();

  const saveNotebook = notebookNameInput => {
    let notebookObject = null;

    // Save the new notebook name
    const notebookName = notebookNameInput.current.value;

    if (!notebookName.trim()) {
      closeModal();
    }

    notebookObject = {
      notebook_name: notebookName,
      app_created_with: 'drynotes_web',
    };

    createNotebook(notebookObject);

    // Reset the input value
    notebookNameInput = null;

    closeModal();
  }

  updateModal({
    visible: true,
    title: 'Create New Notebook',
    sectionClassName: 'create-notebook-modal',
    showCloseModal: false,
    content: renderNotebookContent(notebookNameInput),
    primaryButton: {
      title: 'Save',
      callback: () => {
        saveNotebook(notebookNameInput)
      },
    },
    secondaryButton: {
      title: 'Cancel',
      callback: closeModal,
    },
  });
};